/**
 * WorkbookPage — lightweight inline-edit grid.
 *
 * The legacy Opus workbook leans on Handsontable for spreadsheet-grade UX
 * (formulas, multi-row paste, undo). For Phase 1 of this React port we ship
 * a much lighter custom grid that covers 80% of the day-to-day needs:
 *   - inline edit cells
 *   - tab/shift-tab to move between cells
 *   - add row + delete row
 *   - cells track dirtiness; "Save all" pushes the diff
 *
 * If/when an editor needs formulas or multi-row paste we'll bolt Handsontable
 * back in (it's still in deps); the staged-edit state machine here will keep
 * working underneath either implementation.
 */
import { Outlet } from "react-router-dom";

export function WorkbookPage() {
  return <Outlet />;
}
